import type { ContentProps } from './types'
import { useDisclosureContext } from '../../hooks'
import { twMerge } from 'tailwind-merge'
import { Transition } from '../Transition'

export const Content: React.FC<React.PropsWithChildren<ContentProps>> = ({
  children,
  className,
  tooltipId,
  ...props
}) => {
  const { isOpen } = useDisclosureContext()

  return (
    <Transition.Fade
      as="div"
      show={isOpen}
      role="tooltip"
      className={twMerge('tooltip__content', className)}
      {...props}
    >
      {children}
    </Transition.Fade>
  )
}
